import React from "react";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { colors } from "config/styles/themeColors";

export const messageConfig = {
  success: {
    message: "Всі введені дані були успішно збережені",
    icon: <CheckCircleOutlinedIcon color="success" />,
    title: "УСПІХ!",
    color: colors.green.main,
  },
  error: {
    message: "Виникла помилка, будь-ласка, спробуйте пізніше",
    icon: <ErrorOutlineOutlinedIcon color="error" />,
    title: "ПОМИЛКА!",
    color: colors.error.main,
  },
};
